<p>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_EVENT.EMAIL_EVENT_TITLE' | translate }}</p>
<p class="info">{{ 'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_EVENT.EMAIL_EVENT_INFO' | translate }}</p>

<ng-container *ngIf="(loading$ | async) === false">
  <ng-container *ngIf="template$ | async as template; else noTemplate" class="preview">
    <glxy-form-field>
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_EVENT.EMAIL_HEADER' | translate }}</glxy-label>
      <automata-preview-image-container [imageUrl]="template.previewUrl"></automata-preview-image-container>
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_EVENT.EMAIL_LINK_LABEL' | translate }}</glxy-label>
      <mat-select [formControl]="linkClickedControl" [required]="true">
        <mat-option *ngFor="let opt of linkOptions$ | async" [value]="opt.value">{{ opt.label }}</mat-option>
      </mat-select>
    </glxy-form-field>
  </ng-container>
</ng-container>

<ng-template #noTemplate>
  <glxy-alert type="warning">
    <strong>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_EVENT.MISSING_INFORMATION' | translate }}</strong>
    &mdash;
    <span
      [innerHTML]="'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_EVENT.MISSING_INFORMATION_DETAILS' | translate | iTrustThisHtml"
    ></span>
  </glxy-alert>
</ng-template>
